import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TDR } from 'tdr-common';
import { AddOnOrderSummary } from '../checkout/AddOnOrderSummary';
import { SubHeader } from '../headers/SubHeader';
import { InfoCallout } from '../callouts/InfoCallout';
import { AddonEditDisabledModal } from './AddonEditDisabledModal';
import { hasMandatoryEcommerceSections } from '../../helpers/checkMandatoryEcommerce';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../layouts/CheckoutLayout.module.scss';

type AddOnsProps = {
	addOns: TDR.Reservation.Item[];
	restaurant: TDR.Restaurant;
};

export const AddOns = ({ addOns, restaurant }: AddOnsProps) => {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const hasMandatorySections = hasMandatoryEcommerceSections(restaurant);

	const handleEditClick = (e: React.MouseEvent) => {
		if (hasMandatorySections) {
			e.preventDefault();
			setIsModalOpen(true);
		}
	};

	return (
		<>
			<div className={layoutStyles.Section}>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<SubHeader title={t('titles.add_ons')} />
					{hasMandatorySections ? (
						<button
							onClick={handleEditClick}
							aria-label={t('aria.edit_add_ons', { defaultValue: 'Edit Add Ons' })}
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '4px',
								padding: '6px',
								borderRadius: '12px',
								fontSize: '14px',
								letterSpacing: '2px',
								lineHeight: 1,
								textDecoration: 'none',
								color: 'inherit',
								textTransform: 'uppercase',
								transition: 'all 0.2s ease-in-out',
								background: 'transparent',
								border: 'none',
								cursor: 'pointer'
							}}
						>
							<span>{t('actions.edit', { defaultValue: 'Edit' })}</span>
						</button>
					) : (
						<Link
							to='modify/addons'
							aria-label={t('aria.edit_add_ons', { defaultValue: 'Edit Add Ons' })}
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								gap: '4px',
								padding: '6px',
								borderRadius: '12px',
								fontSize: '14px',
								letterSpacing: '2px',
								lineHeight: 1,
								textDecoration: 'none',
								color: 'inherit',
								textTransform: 'uppercase',
								transition: 'all 0.2s ease-in-out'
							}}
						>
							<span>{t('actions.edit', { defaultValue: 'Edit' })}</span>
						</Link>
					)}
				</div>
				{addOns.every((item) => item.quantity === 0) ? (
					<InfoCallout>
						<span>{t('messages.no_add_ons_selected', { defaultValue: 'No add-on items selected' })}</span>
					</InfoCallout>
				) : (
					<AddOnOrderSummary addOns={addOns} currency={restaurant.currency} />
				)}
			</div>

			<AddonEditDisabledModal
				open={isModalOpen}
				onOpenChange={setIsModalOpen}
			/>
		</>
	);
};
